import React from 'react';

import { useField } from 'formik';

export default function ToggleFormField({ label, ...props }) {
    const [field, meta, helpers] = useField(props);
    return (
        <div className="tw-flex tw-flex-col tw-space-y-1.5">
            <label className="inbud-toggle">
                <input type="checkbox" className="input tw-peer" {...field} {...props} />
                <div className="switch tw-peer peer-checked:tw-bg-blue peer-checked:after:tw-left-[23px]"></div>
                <span className="label peer-disabled:tw-text-charcoal-25">{label}</span>
            </label>
            {meta.touched && meta.error ? <div className="tw-text-red-500 tw-text-sm">{meta.error}</div> : null}
        </div>
    );
}
